import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { ModalProps, GoogleAuthReturn } from "./model";
import {
  MfaOptionsQRCodeService,
  GoogleAuthValidatorService,
  AccountService
} from "../account/account.service";
import { UserQRCode } from "../account/model";
import { Subscription } from "rxjs/Rx";
import { Message } from "primeng/primeng";
import { NgxTranslateService } from "../shared/ngx-translate.service";
import { SecuritySettingsComponent } from "../security/security-settings.component";

@Component({
  moduleId: module.id.toString(),
  selector: "googleAuthSetupWizard",
  template: require('./GoogleAuthenticatorSetupWizard.component.html')
})
export class GoogleAuthSetupWizComponent implements OnInit {
  @Input()
  show: boolean;
  @Input()
  AuthStatus: number = 2;
  @Output()
  primaryBtnClick: EventEmitter<any> = new EventEmitter();
  @Output()
  secondaryBtnClick: EventEmitter<any> = new EventEmitter();
  @Output()
  CloseClick: EventEmitter<any> = new EventEmitter();


  props: ModalProps = {
    title: "",
    primaryBtnLabel: "",
    secondaryBtnLabel: "",
    secondaryBtnOnClickClose: false,
    size: "",
    show: false,
    showSecondaryBtn: false,
    visibleStep: ""
  };

  busy: Subscription;
  phoneType: string = "iPhone";
  qrCode: UserQRCode;
  totpkey: string = "";
  qrCodeSecret: string;
  QRCodeIsInvalid: boolean;
  messages: Message[] = [];

  constructor(
    private accountService: AccountService,
    private qrCodeService: MfaOptionsQRCodeService,
    private googleAuthValidatorService: GoogleAuthValidatorService,
    private translateService : NgxTranslateService,
    private securitySettings: SecuritySettingsComponent
  ) {}

  ngOnInit(): void {
    this.busy = this.qrCodeService.getQRCode().subscribe(
      s => {
        this.qrCode = s;
      },
      error => {
        this.messages.push({
          severity: "error",
          detail: this.translateService.getText("Google_Auth_QR_Retrieve_Error_Msg", "There was an error retrieving QR code."),
          summary: this.translateService.getText("Common.ErrorSummary", "Error!")
        });
        console.log(error);
      }
    );
    this.SetupStepTwo();
  }

  btnPrimary_click() {
    var Step = document.getElementsByClassName("Step");
    let Name = "";
    if (Step.length == 1) {
      Name = <string>Step[0].getAttribute("Name");
      switch (Name) {
        case "Step1":
          this.SetupStepTwo();
          break;
        case "Step2":
          this.SetupStepThree();
          break;
        case "Step3":
          this.ValidateCode();
          break;
        case "Step4":
          this.SetupStepThree();
          break;
      }
    }
  }

  btnSecondary_click() {
    if (this.props.secondaryBtnOnClickClose) this.Close_click("Close");
    else {
      var Step = document.getElementsByClassName("Step");
      let Name = "";
      if (Step.length == 1) {
        Name = <string>Step[0].getAttribute("Name");
        switch (Name) {
          case "Step2":
            break;
          case "Step3":
            break;
        }
      }
    }
  }

  Close_click(returnMessage: string, key: string = null) {
    let ret = new GoogleAuthReturn();
    if (key === null) {
      ret.totpKey = "";
    } else {
      ret.totpKey = key;
    }
    ret.Status = returnMessage;

    this.QRCodeIsInvalid = false;
    this.totpkey = "";
    this.phoneType = "iPhone";
    this.SetupStepTwo();
    this.CloseClick.emit(ret);
  }

  SetupStepTwo() {
    this.props.title = this.translateService.getText("Google_Auth_Setup_Header", "Setup Authenticator");
    this.props.primaryBtnLabel = this.translateService.getText("Common.Continue", "Continue");
    this.props.secondaryBtnLabel = this.translateService.getText("Common.Cancel", "Cancel");
    this.props.secondaryBtnOnClickClose = true;
    this.props.showSecondaryBtn = true;
    this.props.visibleStep = "Step2";
    this.props.size = "small";
  }

  SetupStepThree() {
    this.props.title = this.translateService.getText("Google_Auth_Code_Validating_Header", "Confirm Authenticator Code" );
    this.props.primaryBtnLabel = this.translateService.getText("Common.Verify", "Verify");
    this.props.secondaryBtnLabel = this.translateService.getText("Common.Cancel", "Cancel");
    this.props.secondaryBtnOnClickClose = true;
    this.props.showSecondaryBtn = true;
    this.props.visibleStep = "Step3";
    this.props.size = "small";
  }

  SetupStepFour() {
    this.SetQRCodeSecretString();
    this.props.title = this.translateService.getText("Google_Auth_Setup_Header", "Setup Authenticator");
    this.props.primaryBtnLabel = this.translateService.getText("Common.Continue", "Continue");
    this.props.secondaryBtnLabel = this.translateService.getText("Common.Cancel", "Cancel");
    this.props.secondaryBtnOnClickClose = true;
    this.props.showSecondaryBtn = true;
    this.props.visibleStep = "Step4";
    this.props.size = "small";
  }

  ValidateCode(): void {
    this.busy = this.googleAuthValidatorService
      .validateGoogleAuthCode(this.totpkey)
      .subscribe(
        s => {
          if (s) {
            this.securitySettings.tempToTpKey = this.totpkey; 
            this.securitySettings.onSubmit();
            this.Close_click("Success", this.totpkey);
          } else {
            this.QRCodeIsInvalid = true;
          }
        },
        error => {
          this.messages.push({
            severity: "error",
            detail: this.translateService.getText("Google_Auth_Code_Validating_Error_Msg", "There was an error validating code." ),
            summary: this.translateService.getText("Common.ErrorSummary", "Error!")
          });
        }
      );
  }

  ValidateCode_Change(e: string) {
    let totpkeylength = this.totpkey.toString().length;
    if (this.QRCodeIsInvalid) {
      this.QRCodeIsInvalid = false;
    }
  }

  IssuesScanning_Click() {
    this.SetupStepFour();
  }

  ScanQRCode_Click() {
    this.SetupStepTwo();
  }

  SetQRCodeSecretString() {
    let str = "";
    let i = 0;
    while (i < this.qrCode.Secret.length / 4) {
      str += this.qrCode.Secret.substr(i * 4, 4) + " ";
      i++;
    }
    this.qrCodeSecret = str;
  }

  InputCode_KeyUp(e: any) {
    if (e.keyCode === 13) {
      // enter key code
      this.btnPrimary_click();
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/security/GoogleAuthenticatorSetupWizard.component.ts